import { useTranslation } from 'react-i18next';
import './style.scss';

import { IBillingInfo, IPaybPayment } from '@src/global/types/types';
import { Payment } from '../Payment';
import { IShippingInfo } from '@src/pages/checkout/components/ShippingInformation/types';
import { CountryService } from '@global/utils/CountryService';
import { store } from '@global/store/store';
import { RootState } from '@global/store/store';

interface OrderInfoProps {
  billingInfo: IBillingInfo;
  shippingInfo: IShippingInfo;
  isShowShippingInfo?: boolean;
  paymentInfo: IPaybPayment;
}

export const AddressInfo = ({
  billingInfo,
  shippingInfo,
  isShowShippingInfo = false,
  paymentInfo,
}: OrderInfoProps) => {
  const { t } = useTranslation();
  const { country: countryState } = store.getState() as RootState;

  const billingCountry = billingInfo?.country?.iso2Code
    ? CountryService.getCountryByIsoCode(
        countryState.countries,
        billingInfo.country.iso2Code
      )
    : undefined;

  const shippingCountry = shippingInfo?.country?.iso2Code
    ? CountryService.getCountryByIsoCode(
        countryState.countries,
        shippingInfo.country.iso2Code
      )
    : undefined;

  const displayBillingState =
    billingCountry && billingInfo?.state
      ? CountryService.convertChinaStateCodeForDisplay(
          billingCountry,
          billingInfo.state
        )
      : billingInfo?.state;

  const displayShippingState =
    shippingCountry && shippingInfo?.state
      ? CountryService.convertChinaStateCodeForDisplay(
          shippingCountry,
          shippingInfo.state
        )
      : shippingInfo?.state;

  return (
    <div className="address-info">
      <div>
        <p className="address-info__column-header">
          {t('confirmation.details.billingAddress')}
        </p>
        <p className="address-info__column-value">{billingInfo?.name}</p>
        <p className="address-info__column-value">{billingInfo?.addressOne}</p>
        <p className="address-info__column-value">{billingInfo?.addressTwo}</p>
        <p className="address-info__column-value">
          {billingInfo?.city}, {displayBillingState} {billingInfo?.zip}
        </p>
        <p className="address-info__column-value">
          {billingInfo?.country?.name}
        </p>
        <p className="address-info__column-value">
          Phone number: {billingInfo?.tel}
        </p>
      </div>
      {isShowShippingInfo && (
        <div>
          <p className="address-info__column-header">
            {t('confirmation.details.shippingAddress')}
          </p>
          <p className="address-info__column-value">
            {shippingInfo?.firstName} {shippingInfo?.lastName}
          </p>
          <p className="address-info__column-value">
            {shippingInfo?.addressOne}
          </p>
          <p className="address-info__column-value">
            {shippingInfo?.addressTwo}
          </p>
          <p className="address-info__column-value">
            {shippingInfo?.city}, {displayShippingState} {shippingInfo?.zip}
          </p>
          <p className="address-info__column-value">
            {shippingInfo?.country?.name}
          </p>
          <p className="address-info__column-value">{shippingInfo?.phone}</p>
        </div>
      )}
      <div>
        <p className="address-info__column-header">
          {t('confirmation.details.paymentMethod')}
        </p>
        <div className="order-confirmation__payment-details">
          <Payment paymentInfo={paymentInfo} />
        </div>
      </div>
    </div>
  );
};
